const {registerModule} = window;

class ModuleScripts {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  isElementInViewOnce(element, callback, inViewThreshold) {
    // Executes the callback function once when the element is in view. Additional calls to the function after the callback has executed will be ignored.

    // element = the element to watch if in view
    // callback = function to call when the element is in view
    // inViewThreshold = 0 to 1 decimal value determining how far past the element the user must scroll before firing the callback (ex: 0.75 means the 75% of the element must be in view before firing the callback)

    if (!IntersectionObserver) {
      // Do nothing if the browser doesn't support IntersectionObserver
      return;
    }

    let observer = null;
    const handleIntersection = (entries) => {
      entries.map((entry) => {
        if (entry.isIntersecting) {
          // Pass the element that scrolled into view back to the callback (slightly different than chart.js) so the callback can access it if needed
          callback(element);
          observer.disconnect();
        }
      });
    };
    observer = new IntersectionObserver(handleIntersection, {threshold: inViewThreshold});
    observer.observe(element);
  }

  autoplayVideoWhenInView() {
    this.isElementInViewOnce(this.element, (videoElement) => {
      videoElement.play();
    }, this.inViewThreshold);
  }

  initialize() {
    this.setVars();
    if (this.inViewThreshold >= 0 && this.inViewThreshold <= 1 && this.videoElement) {
      // Check the attributes on the passed in this.element to determine if this is a video element that should be autoplayed when in view
      this.autoplayVideoWhenInView();
    }
    // This macro can be used to call other scripts unrelated to autoplaying videos here. You can call other functions based on data attributes here:
    // else if (lookAtTheDataAtrributesOnTheElementToDetermineWhatFunctionToCall) {...}
  }

  setVars() {
    this.inViewThresholdDefaultValue = 0.5;
    this.inViewThreshold = parseFloat(this.element.getAttribute('data-autoplay-after-percent-of-video-visible')) / 100 || this.inViewThresholdDefaultValue;
    this.videoElement = this.element.tagName === 'VIDEO' ? this.element : null;
  }
}

registerModule('ModuleScripts', ModuleScripts);
